import { AfterViewInit, Component, OnInit, SimpleChanges } from '@angular/core';
import { format } from 'date-fns';
import * as vnMap from '../../../../../../vietnam_new.json';
import { vi } from 'date-fns/locale';
import { DashboardService } from './../../../../../shared/services/dashboard.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// import * as Highcharts from 'highcharts';
// import HighchartsMap from 'highcharts/modules/map';
// Initialize Highcharts exporting module
import { MatTableDataSource } from '@angular/material/table';
import vn_prov from '../../../../../../output_file.json';
import vn_code from '../../../../../../vn_provi.json';
import prov_name from '../../../../../../prov_name.json';
import { FormControl, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { MatButtonToggleChange } from '@angular/material/button-toggle';
// import syncCharts from './syncAddition';
//
// syncCharts(Highcharts);
import HighchartsESM from 'highcharts/es-modules/masters/highcharts.src';
import {loadHighcharts} from '../../../../../shared/highcharts';

export interface PeriodicElement {
    name: string;
    count: number;
    nam: number;
    nu: string;
}

const categories = [
    '0-4',
    '5-9',
    '10-14',
    '15-19',
    '20-24',
    '25-29',
    '30-34',
    '35-40',
    '40-45',
    '45-49',
    '50-54',
    '55-59',
    '60-64',
    '65-69',
    '70-74',
    '75-79',
    '80-84',
    '85+',
];

import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
    selector: 'app-dashboard-mccd',
    templateUrl: './dashboard-mccd.component.html',
    styleUrls: ['./dashboard-mccd.component.scss'],
})
export class DashboardMccdComponent implements AfterViewInit, OnInit {
    public Highcharts: typeof HighchartsESM | null = null;
    displayedColumns: string[] = ['name', 'count', 'nam', 'nu'];
    vn_prov_d = vn_prov;
    myControl = new FormControl();
    filteredOptions: Observable<any[]>;
    dataSource = new MatTableDataSource<PeriodicElement>([]);
    colorDef: any = null;
    totalItems = 0;
    startDate: Date;
    endDate: Date;
    textBoxData: any = {
        total_death: 0,
        day_gap: 0,
        asc: false,
        transform: 0,
    };
    dateType?: string = 'day';
    stateForm = this._formBuilder.group({
        vn_prov_d: 'Cả nước',
    });

    displayValue = 'grid';
    displayValueType = 'num';
    displayValueCode = 'code4';
    stateGroupOptions: Observable<any[]>;
    //sync
    chart: any;
    viewType = '1';
    list_hos: string[];
    list_dis: string[];
    list_hos_s: FormControl<string[] | null> = new FormControl<string[] | null>(null);
    list_dis_s: FormControl<string[] | null> = new FormControl<string[] | null>(null);
    prov_name: string[] = prov_name;
    prov_name_s: FormControl<string[] | null> = new FormControl<string[] | null>(null);
    chartCallback: any;
    dataGroup100: any;
    i: any;
    constructor(
        @Inject(MAT_DATE_FORMATS) private myFormats: any,
        private dateAdapter: DateAdapter<Date>,
        private dashboardService: DashboardService,
        private _formBuilder: FormBuilder,
        private toastService: ToastrService,
        private sanitizer: DomSanitizer
    ) {
        this.dateAdapter.setLocale('vi-VN'); // Đặt ngôn ngữ mặc định
    }
    get provNameArray(): string[] {
        return this.prov_name_s.value || [];
    }
    get hosArray(): string[] {
        return this.list_hos_s.value || [];
    }
    get disArray(): string[] {
        return this.list_dis_s.value || [];
    }
    syncExtremes(e: any) {
        var thisChart = this.chart;
        if (e.trigger !== 'syncExtremes') {
            // Prevent feedback loop
            this.Highcharts?.each(this.Highcharts.charts, function (chart: any) {
                if (chart !== thisChart) {
                    if (chart.xAxis[0].setExtremes) {
                        // It is null while updating
                        chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
                            trigger: 'syncExtremes',
                        });
                    }
                }
            });
        }
    }
    ngOnInit() {
        this.stateGroupOptions = this.stateForm.get('vn_prov_d')!.valueChanges.pipe(
            startWith(''),
            map((value) => this._filterGroup(value || ''))
        );
    }
    addHighlight(e: any) {
        let point, event;
        const charts = this.Highcharts?.charts;
        charts?.forEach((chart, index) => {
            if (chart) {
                chart = charts[index];
                // Find coordinates within the chart
                event = chart?.pointer.normalize(e);
                // Get the hovered point
                point = (chart?.series[0] as any).searchPoint(event, true);
                if (point) {
                    point.highlight(e);
                }
            }
        });
    }
    ngAfterViewInit() {
        // Use ngAfterViewInit
        loadHighcharts().then(Highcharts => {
            this.Highcharts = Highcharts;
            this.colorDef = this.Highcharts?.getOptions().colors?.at(0);
            this.textBox();
            this.line();
            this.table();
            this.initializeVietNam();
            this.getDisease();
            this.bubbleGroup();
            this.negaBar();
            this.syncChart();
            this.gridChart();
            this.getHospital();
        })
    }
    tNum(number: number): string {
        if (number > 1000) {
            return (number / 1000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ',000';
        } else {
            return number.toString();
        }
    }
    reSync() {
        if (this.startDate && this.endDate) {
            const param = `?&from=${format(this.startDate, 'yyyy-MM-dd')}&to=${format(
                this.endDate,
                'yyyy-MM-dd'
            )}&view=${this.viewType}&city=${
                this.prov_name_s.value?.map((item) => this.getCodeUnknow(item)).join(',') || ''
            }&csyt=${this.list_hos_s.value?.join(',') || ''}&mabenh=${
                this.list_dis_s.value?.join(',') || ''
            }`;
            this.syncChart(param);
        } else {
            const param = `?&from=${format(
                new Date().setDate(new Date().getDate() - 28),
                'yyyy-MM-dd'
            )}&to=${format(new Date(), 'yyyy-MM-dd')}&view=${this.viewType}&city=${
                this.prov_name_s.value?.map((item) => this.getCodeUnknow(item)).join(',') || ''
            }&csyt=${this.list_hos_s.value?.join(',') || ''}&mabenh=${
                this.list_dis_s.value?.join(',') || ''
            }`;
            this.syncChart(param);
        }
    }

    syncChart(param?: string) {
        const container = document.getElementById('boxChart__container');
        if (container) {
            container.addEventListener('mousemove', this.handleChartEvents);
            container.addEventListener('touchmove', this.handleChartEvents);
            container.addEventListener('touchstart', this.handleChartEvents);
        }
        this.dashboardService.sync(param || '?from=&to=').subscribe(
            (results: any) => {
                const dom_chart = document.getElementById('boxChart__container');
                if (dom_chart) {
                    const html = results.datasets
                        .map(
                            (_: any, i: any) => `
                <div id="chartSync${i}"></div>
                `
                        )
                        .join('');
                    dom_chart.innerHTML = `<div style="grid-template-columns: repeat(${Math.round(
                        results.datasets.length / 2
                    )}, minmax(0, 1fr));" class=" grid">${html}</div>`;
                }
                results.datasets.forEach((dataset: any, i: any) => {
                    const data = dataset.data.map((val: any, j: any) => [results.xData[j], val]);
                    this.Highcharts?.chart(`chartSync${i}`, {
                        chart: {
                            marginLeft: 40, // Keep all charts left aligned
                            spacingTop: 20,
                            spacingBottom: 20,
                            height: 250,
                            zooming: {
                                type: 'x',
                            },
                        },
                        exporting: {
                            enabled: false,
                        },
                        title: {
                            text: dataset.name,
                            align: 'left',
                            margin: 0,
                            x: 30,
                        },
                        credits: {
                            enabled: false,
                        },
                        legend: {
                            enabled: false,
                        },
                        xAxis: {
                            crosshair: true,
                            events: {
                                setExtremes: this.syncExtremes,
                            },
                            type: 'datetime',
                        },
                        yAxis: {
                            title: {
                                text: null,
                            },
                            crosshair: true,
                        },
                        tooltip: {
                            positioner: function (this: any) {
                                return {
                                    // right aligned
                                    x: this.chart.chartWidth - this.label.width,
                                    y: 10, // align to title
                                };
                            },
                            borderWidth: 0,
                            backgroundColor: 'none',
                            pointFormat: '{point.y}',
                            headerFormat: '',
                            shadow: false,
                            style: {
                                fontSize: '18px',
                            },
                            valueDecimals: 0,
                        },
                        plotOptions: {
                            series: {
                                marker: {
                                    enabledThreshold: 4,
                                },
                            },
                        },
                        series: [
                            {
                                data: data,
                                name: dataset.name,
                                type: dataset.type,
                                color: (this.Highcharts.getOptions() as any).colors[i],
                                fillOpacity: 0.3,
                                tooltip: {
                                    valueSuffix: ' ' + dataset.unit,
                                },
                            },
                        ],
                    } as any);
                });
            },
            (err) => {
                this.toastService.error(`Có lỗi xảy ra`, 'Thất bại');
            }
        );
    }

    handleChartEvents(e: any) {
        let chart: Highcharts.Chart;
        let point: Highcharts.Point | undefined;
        let event: Highcharts.PointerEventObject;
        let loop_length = 0;
        if (this.Highcharts) {
            loop_length = this.Highcharts.charts.length;
        }
        for (let i = 0; i < loop_length; i++) {
            chart = this.Highcharts?.charts[i] as Highcharts.Chart;
            if (!chart) continue;
            event = chart.pointer.normalize(e); // Find coordinates within the chart
            // Adjust event.chartX if necessary (custom logic)
            event.chartX = e.offsetX;

            point = chart.series[0].searchPoint(event, true); // Get the hovered point
            if (point) {
                (point as any).highlight(e);
            }
        }
    }
    onDisplayChange(event: any): void {
        this.displayValue = event.value;
        this.reRenderGrid();
    }

    onDisplayValueTypeChange(event: any): void {
        this.displayValueType = event.value;
        this.reRenderGrid();
    }

    onDisplayValueCodeChange(event: any): void {
        this.displayValueCode = event.value;
        this.reRenderGrid();
    }

    onViewTypeChange(event: any): void {
        this.viewType = event.value;
        this.reSync();
    }
    reRenderGrid() {
        if (this.startDate && this.endDate) {
            const param = `?&from=${format(this.startDate, 'yyyy-MM-dd')}&to=${format(
                this.endDate,
                'yyyy-MM-dd'
            )}&type=${this.displayValueType}&display=${this.displayValue}`;
            this.gridChart(param);
        } else {
            const param = `?&from=${format(
                new Date().setDate(new Date().getDate() - 28),
                'yyyy-MM-dd'
            )}&to=${format(new Date(), 'yyyy-MM-dd')}&type=${this.displayValueType}&display=${
                this.displayValue
            }&code=${this.displayValueCode}`;
            this.gridChart(param);
        }
    }
    reGenerate() {
        if (this.startDate && this.endDate) {
            const param = `?city=${this.getCode()}&from=${format(
                this.startDate,
                'yyyy-MM-dd'
            )}&to=${format(this.endDate, 'yyyy-MM-dd')}&type=${this.dateType}`;
            const paramDate = `?city=${this.getCode()}&from=${format(
                this.startDate,
                'yyyy-MM-dd'
            )}&to=${format(this.endDate, 'yyyy-MM-dd')}`;
            const paramOnly = `?from=${format(this.startDate, 'yyyy-MM-dd')}&to=${format(
                this.endDate,
                'yyyy-MM-dd'
            )}`;
            this.line(param);
            this.bubbleGroup(paramDate);
            this.table(paramDate);
            this.negaBar(paramDate);
            this.textBox(paramDate);
            this.initializeVietNam(paramOnly);
            this.gridChart(paramOnly);

            this.toastService.success('Thống kê thành công!', 'Thành công');
        }
        if ((this.startDate && !this.endDate) || (!this.startDate && this.endDate)) {
            this.toastService.error('Nhập đủ hoặc bỏ trống 2 trường để thống kê', 'Thất bại');
        }
    }
    getCode() {
        const city = this.stateForm.get('vn_prov_d');
        if (city !== null && (this.startDate !== null || this.endDate !== null)) {
            // Kiểm tra city không null và startDate hoặc endDate không null
            const cityName: string | null = city.value;

            if (cityName !== null && vn_code.hasOwnProperty(cityName)) {
                // Kiểm tra xem cityName không null và có trong danh sách mã code không
                return vn_code[cityName];
            }
        }
    }
    getCodeUnknow(name: string) {
        const city = name;
        if (city !== null && (this.startDate !== null || this.endDate !== null)) {
            // Kiểm tra city không null và startDate hoặc endDate không null
            const cityName: string | null = city;

            if (cityName !== null && vn_code.hasOwnProperty(cityName)) {
                // Kiểm tra xem cityName không null và có trong danh sách mã code không
                return vn_code[cityName];
            }
        }
    }
    onPageChange(event: any) {
        if (this.startDate && this.endDate) {
            this.table(
                `?from=${format(this.startDate, 'yyyy-MM-dd')}&to=${format(
                    this.endDate,
                    'yyyy-MM-dd'
                )}&city=${this.getCode()}&page=${event.pageIndex + 1}`
            );
        } else {
            this.table(`?page=${event.pageIndex + 1}&city=${this.getCode()}`);
        }
    }
    sanitizeHTML(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    textBox(param?: string) {
        this.dashboardService.textBox(param || '').subscribe((results: any) => {
            this.textBoxData = results;
        });
    }
    startDateChanged(event: any) {
        this.startDate = event.value;
    }

    endDateChanged(event: any) {
        this.endDate = event.value;
    }
    table(param?: string) {
        this.dashboardService.table(param || '').subscribe((results: any) => {
            this.totalItems = results.totalRow;
            this.dataSource = results.data;
        });
    }
    gridChart(param?: string) {
        this.dashboardService.group100(param || '').subscribe((results: any) => {
            this.dataGroup100 = results;
        });
    }
    onOptionSelected(event: MatAutocompleteSelectedEvent) {
        this.city_main = event.option.value;
        if (this.startDate && this.endDate) {
            this.line(
                `?from=${format(this.startDate, 'yyyy-MM-dd')}&to=${format(
                    this.endDate,
                    'yyyy-MM-dd'
                )}&city=${this.getCode()}`
            );
            this.table(
                `?from=${format(this.startDate, 'yyyy-MM-dd')}&to=${format(
                    this.endDate,
                    'yyyy-MM-dd'
                )}&city=${this.getCode()}&page=1`
            );
        } else {
            this.line(`?city=${this.getCode()}`);
            this.table(`?page=1&city=${this.getCode()}`);
        }
    }
    city_main = 'Cả nước';
    getCity() {
        return this.city_main;
    }
    getDisease(param?: string) {
        this.dashboardService.disease(param || '').subscribe((results: any) => {
            this.list_dis = results;
            this.filteredDis = this.list_dis as any;
        });
    }
    getHospital(param?: string) {
        this.dashboardService.hospital(param || '').subscribe((results: any) => {
            this.list_hos = results.map((item: any) => item.TENCSKCB);
            this.filteredHos = this.list_hos as any;
        });
    }
    formatDateLine(date?: Date, type?: string) {
        if (type) {
            if (this.dateType === 'day') {
                return format(date || new Date().setDate(new Date().getDate() - 28), 'dd/MM/yyyy', {
                    locale: vi,
                });
            }
            if (this.dateType === 'month') {
                return (
                    'T' +
                    format(date || new Date().setDate(new Date().getDate() - 28), 'M, yyyy', {
                        locale: vi,
                    })
                );
            }
            if (this.dateType === 'year') {
                return format(date || new Date().setDate(new Date().getDate() - 28), 'yyyy', {
                    locale: vi,
                });
            }
        } else {
            if (this.dateType === 'day') {
                return format(date || new Date(), 'dd/MM/yyyy', {
                    locale: vi,
                });
            }
            if (this.dateType === 'month') {
                return (
                    'T' +
                    format(date || new Date(), 'M, yyyy', {
                        locale: vi,
                    })
                );
            }
            if (this.dateType === 'year') {
                return format(date || new Date(), 'yyyy', {
                    locale: vi,
                });
            }
        }
        return '';
    }
    formatDate2(date?: Date, type?: string) {
        if (type) {
            return format(date || new Date().setDate(new Date().getDate() - 28), 'dd/MM/yyyy', {
                locale: vi,
            });
        } else {
            return format(date || new Date(), 'dd/MM/yyyy', { locale: vi });
        }
    }

    formatDate(date?: Date, type?: string) {
        if (type) {
            return format(
                date || new Date().setDate(new Date().getDate() - 28),
                "dd 'tháng' M, yyyy",
                { locale: vi }
            );
        } else {
            return format(date || new Date(), "dd 'tháng' M, yyyy", { locale: vi });
        }
    }
    line(param?: string) {
        this.dashboardService.line(param || '').subscribe((results: any) => {
            this.Highcharts?.chart('chart1', {
                chart: {
                    type: 'line',
                    zoomType: 'x',
                },
                title: {
                    text: `Theo dõi tình hình tử vong ${this.getCity()}, từ ${this.formatDateLine(
                        this.startDate,
                        's'
                    )} đến ${this.formatDateLine(this.endDate)}`,
                    align: 'left',
                    style: {
                        fontFamily: 'Roboto',
                        fontWeight: 'bold',
                    },
                },
                subtitle: {
                    text:
                        document.ontouchstart === undefined
                            ? 'Nhấp và kéo trong vùng vẽ để phóng to'
                            : 'Chụm biểu đồ để phóng to',
                    align: 'left',
                    style: {
                        fontFamily: 'Roboto',
                    },
                },
                xAxis: {
                    // crosshair: {
                    //     dashStyle: 'shortdot',
                    //     color: Highcharts.getOptions().colors?.at(0),
                    // },
                    type: 'datetime',
                    categories: results.x,
                },
                yAxis: {
                    // title: {
                    //     text: 'Exchange rate',
                    // },
                    // crosshair: {
                    //     dashStyle: 'shortdot',
                    //     color: Highcharts.getOptions().colors?.at(0),
                    // },
                },
                legend: {
                    enabled: false,
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1,
                            },
                            stops: [
                                [0, this.Highcharts.getOptions().colors?.at(0)],
                                [
                                    1,
                                    this.Highcharts.color(this.Highcharts.getOptions().colors?.at(0) as any)
                                        .setOpacity(0)
                                        .get('rgba'),
                                ],
                            ],
                        },
                        marker: {
                            radius: 2,
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1,
                            },
                        },
                        threshold: null,
                    },
                },

                series: [
                    {
                        type: 'area',
                        name: 'Số người tử vong',
                        data: results.y,
                    },
                ],
            } as any);
        });
    }
    private _filterGroup(value: string): any[] {
        if (value) {
            return this.vn_prov_d
                .map((group: any) => ({ letter: group.letter, names: _filter(group.names, value) }))
                .filter((group: any) => group.names.length > 0);
        }

        return this.vn_prov_d;
    }
    onDateTypeChange(event: MatButtonToggleChange) {
        if (this.startDate && this.endDate) {
            const param = `?city=${this.getCode()}&from=${format(
                this.startDate,
                'yyyy-MM-dd'
            )}&to=${format(this.endDate, 'yyyy-MM-dd')}&type=${this.dateType}`;
            this.line(param);
        }
        if (!this.startDate && !this.endDate) {
            const param = `?city=${this.getCode()}&type=${this.dateType}`;
            this.line(param);
        }
    }
    bubbleGroup(param?: string) {
        this.dashboardService.bubble(param || '').subscribe((results: any) => {
            this.Highcharts?.chart('chart-bubble', {
                chart: {
                    type: 'packedbubble',
                    height: '450px',
                },
                title: {
                    text: 'Biểu diễn số lượng người tử vong theo giới tính',
                    align: 'left',
                    style: {
                        fontFamily: 'Roboto',
                        fontWeight: 'bold',
                    },
                },
                subtitle: {
                    text: `${this.getCity()}, từ ${this.formatDateLine(
                        this.startDate,
                        's'
                    )} đến ${this.formatDateLine(this.endDate)}`,
                    align: 'left',
                    style: {
                        fontFamily: 'Roboto',
                        fontSize: 14,
                        color: 'black',
                    },
                },
                tooltip: {
                    useHTML: true,
                    pointFormat: '<b>{point.name}:</b> {point.value} người',
                },
                plotOptions: {
                    packedbubble: {
                        minSize: '40%',
                        maxSize: '100%',
                        zMin: 0,
                        zMax: 1000,
                        layoutAlgorithm: {
                            gravitationalConstant: 0.05,
                            splitSeries: true,
                            seriesInteraction: false,
                            dragBetweenSeries: false,
                            parentNodeLimit: true,
                        },
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}',
                            filter: {
                                property: 'y',
                                operator: '>',
                                value: 10,
                            },
                            style: {
                                color: 'black',
                                textOutline: 'none',
                                fontWeight: 'normal',
                            },
                        },
                    },
                },

                series: results,
            } as any);
        });
    }
    negaBar(param?: string) {
        this.dashboardService.nega(param || '').subscribe((results: any) => {
            this.Highcharts?.chart('chart-nega', {
                chart: {
                    type: 'bar',
                },
                title: {
                    text: 'Biểu đồ thể hiện tình hình tử vong của các nhóm tuổi',
                    align: 'left',
                    style: {
                        fontFamily: 'Roboto',
                        fontWeight: 'bold',
                    },
                },
                subtitle: {
                    text: `${this.getCity()}, từ ${this.formatDateLine(
                        this.startDate,
                        's'
                    )} đến ${this.formatDateLine(this.endDate)}`,
                    align: 'left',
                    style: {
                        fontFamily: 'Roboto',
                        fontSize: 14,
                        color: 'black',
                    },
                },
                accessibility: {
                    point: {
                        valueDescriptionFormat: '{index}. Age {xDescription}, {value}%.',
                    },
                },
                xAxis: [
                    {
                        categories: categories,
                        reversed: false,
                        labels: {
                            step: 1,
                        },
                        accessibility: {
                            description: 'Age (male)',
                        },
                    },
                    {
                        // mirror axis on right side
                        opposite: true,
                        reversed: false,
                        categories: categories,
                        linkedTo: 0,
                        labels: {
                            step: 1,
                        },
                        accessibility: {
                            description: 'Age (female)',
                        },
                    },
                ],
                yAxis: {
                    title: {
                        text: null,
                    },
                    labels: {
                        formatter(this: { value: number }) {
                            return Math.abs(this.value) + '%';
                        },
                    },
                    accessibility: {
                        description: 'Percentage population',
                        rangeDescription: 'Range: 0 to 5%',
                    },
                },

                plotOptions: {
                    series: {
                        stacking: 'normal',
                        borderRadius: 5,
                    },
                },

                tooltip: {
                    formatter(this: any): string {
                        const absY = Math.abs(this.point.y);
                        return `<b>${this.series.name}, age ${
                            this.point.category
                        }</b><br/>Population: ${absY.toFixed(1)}%`;
                    },
                },

                series: results,
            } as any);
        });
    }
    initializeVietNam(param?: string) {
        this.dashboardService.vn(param || '?from=&to=').subscribe((results: any) => {
            this.Highcharts?.mapChart('chart-vn', {
                chart: {
                    map: vnMap,
                },
                title: {
                    text: 'Phân bố tử vong theo địa lý',
                    style: {
                        fontFamily: 'Roboto',
                        fontWeight: 'bold',
                    },
                },

                subtitle: {
                    text: '',
                    style: {
                        fontFamily: 'Roboto',
                    },
                },

                mapNavigation: {
                    enabled: true,
                    buttonOptions: {
                        verticalAlign: 'bottom',
                    },
                },

                colorAxis: {
                    min: 0,
                },

                series: [
                    {
                        data: results,
                        name: 'Số ca tử vong',
                        states: {
                            hover: {
                                color: '#BADA55',
                            },
                        },
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}',
                        },
                    },
                ],
            } as any);
        });
    }
    saveStateKey1 = '';
    saveStateKey2 = '';
    saveStateKey3 = '';
    filteredProvName = prov_name;
    filteredHos: any = [];
    filteredDis: any = [];
    onOpenedChange1(isOpened: boolean) {
        if (!isOpened) {
            this.resetIP1();
        }
    }
    onOpenedChange2(isOpened: boolean) {
        if (!isOpened) {
            this.resetIP2();
        }
    }
    onOpenedChange3(isOpened: boolean) {
        if (!isOpened) {
            this.resetIP3();
        }
    }
    resetIP1() {
        this.saveStateKey1 = '';
        this.filteredProvName = this.prov_name;

        const a_code = this.prov_name_s.value?.map((item) => this.getCodeUnknow(item));
        if (a_code) {
            this.getHospital(`?city=${a_code?.join(',')}`);
        }
    }
    resetIP2() {
        this.saveStateKey2 = '';
        this.filteredHos = this.list_hos as any;
    }
    resetIP3() {
        this.saveStateKey2 = '';
        this.filteredDis = this.list_dis as any;
    }
    onKeydownIP1(event: KeyboardEvent): void {
        if (event.key === 'Backspace') {
            // Remove the last character from saveStateKey1
            this.saveStateKey1 = this.saveStateKey1.slice(0, -1);
        }
        if (event.key.length === 1) {
            this.saveStateKey1 += event.key;
        }
        this.filteredProvName = this.prov_name.filter((val) =>
            this.saveStateKey1.length > 0
                ? this.removeAccents(val).toLowerCase().includes(this.saveStateKey1.toLowerCase())
                : val
        );
    }
    removeAccents(str: string): string {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    onKeydownIP2(event: KeyboardEvent): void {
        if (event.key.length !== 1 && event.key !== ' ' && event.key !== 'Space') {
            if (event.key === 'Backspace') {
                // Remove the last character from saveStateKey1
                this.saveStateKey1 = this.saveStateKey1.slice(0, -1);
            }
            return;
        }

        this.saveStateKey1 += event.key;
        this.filteredHos = this.list_hos.filter((val) =>
            val.toLowerCase().includes(this.saveStateKey2.toLowerCase())
        );
    }
    onKeydownIP3(event: KeyboardEvent): void {
        if (event.key.length !== 1 && event.key !== ' ' && event.key !== 'Space') {
            if (event.key === 'Backspace') {
                // Remove the last character from saveStateKey1
                this.saveStateKey3 = this.saveStateKey3.slice(0, -1);
            }
            return;
        }
        this.saveStateKey3 += event.key;
        this.filteredDis = this.list_dis.filter((val) =>
            val.toLowerCase().includes(this.saveStateKey3.toLowerCase())
        );
    }
}
export const _filter = (opt: string[], value: string): string[] => {
    const filterValue = value.toLowerCase();

    return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

